import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/presentations/presentations/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`The presentation system uses system fonts. The default font is Helvetica Neue. The default monospace font is Menlo in Keynote and Roboto Mono in Google Slides.`}</p>
    <h3>{`Font sizing`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Keynote`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Google Slides`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`H1`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`100`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`40`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`H2`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`72`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`30`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`H3`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`64`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`24`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`H4`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`56`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`18`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Body`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`48`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`16`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Monospace fonts`}</h3>
    <p>{`Monospace fonts are used for quote attributions, code, and eyebrow text.`}</p>
    <img width="656" alt="Example: Type pairings. Eyebrow text is a descriptive keyword or phrase placed above the main headline" src="https://user-images.githubusercontent.com/10384315/102410620-a37d8c80-3fa5-11eb-8db6-f49738061205.png" />
    <h3>{`Highlighting`}</h3>
    <p>{`Highlighting is great for indicating important points that you'd like your audience to remember from a statement or quote. In Primer Presentations, highlights are represented by altering the color of the text.`}</p>
    <p><strong parentName="p">{`Usage guidelines:`}</strong></p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Avoid multiple highlights.`}</strong>{` Highlights should be used sparingly to only highlight key words or phrases on the slide. Too many highlights will confuse your audience about what the most important take away should be.`}</li>
      <li parentName="ul"><strong parentName="li">{`Emphasis over decoration`}</strong>{` Remember that when you're highlighting text you're telling the audience, "This is important". Be sure to ask yourself if the highlight is necessary to add emphasis to your talking point.`}</li>
    </ul>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://user-images.githubusercontent.com/10384315/55268057-cef59c00-5243-11e9-8400-6381fae36fea.png" />
    <Caption mdxType="Caption">Highlight important points that your audience should pay attention to</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://user-images.githubusercontent.com/10384315/55268059-d7e66d80-5243-11e9-9842-37d4009dfb9e.png" />
    <Caption mdxType="Caption">Don't use too many highlights</Caption>
  </Dont>
    </DoDontContainer>
    <h4>{`Recommended highlight color pairings`}</h4>
    <p>{`All highlight colors come from the `}<a parentName="p" {...{
        "href": "https://primer.style/css/support/color-system"
      }}>{`Primer color system`}</a>{`. We've supplied a list of recommended highlight colors below.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Background`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Highlight`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Hex value`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Black`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`yellow-400`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`#ffdf5d`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Black`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`blue-400`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`#2188ff`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Black`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`red-400`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`#ea4a5a`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`White`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`blue-600`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`#005cc5`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`White`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`red-500`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`#d73a49`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      